const en = {
  "app.tagline": "Premium Online Game Marketplace",
  "nav.marketplace": "Marketplace",
  "nav.orders": "Orders",
  "nav.dashboard": "Dashboard",
  "nav.chat": "Messages",
  "nav.login": "Login",
  "nav.register": "Register",
  "nav.logout": "Logout",
  "nav.stock": "Stock",
  "nav.suppliers": "Suppliers",
  "nav.reports": "Reports",
  "nav.settings": "Settings",
  "nav.submit_stock": "Submit Stock",
  "nav.admin": "Manage",
  "nav.account": "Account",
  "nav.supplier_prices": "Supplier Prices",
  "nav.members": "Users",
  "landing.hero.title": "Trusted Online Game Trading",
  "landing.hero.sub": "Coins, accounts, items, and boosting services from MQL Group. Safe transactions, fast delivery.",
  "landing.cta.browse": "Browse Products",
  "landing.cta.register": "Register Now",
  "landing.f1.title": "Secure Transactions",
  "landing.f1.desc": "Payments are verified by the MQL Group team",
  "landing.f2.title": "Fast Delivery",
  "landing.f2.desc": "Average delivery under 30 minutes",
  "landing.f3.title": "Verified Suppliers",
  "landing.f3.desc": "Stock only from KYC-verified suppliers",
  "landing.f4.title": "Premium Service",
  "landing.f4.desc": "24/7 chat support from expert staff",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Name",
  "auth.role": "Register as",
  "auth.role.buyer": "Buyer",
  "auth.role.supplier": "Supplier",
  "auth.login": "Login",
  "auth.register": "Register",
  "auth.have_account": "Already have an account?",
  "auth.no_account": "Don't have an account?",
  "auth.forgot": "Forgot password?",
  "auth.welcome_back": "Welcome back",
  "auth.welcome": "Welcome",
  "auth.login_failed": "Login failed",
  "auth.register_failed": "Registration failed",
  "auth.accept_prefix": "I have read and agree to the",
  "auth.policy.buyer": "Buyer Policy",
  "auth.policy.supplier": "Supplier Policy",
  "kyc.notice": "Suppliers must complete KYC verification. Your account can be used once Admin approves your ID card. Photos are only visible to the Owner & Staff.",
  "kyc.telegram": "Telegram Username",
  "kyc.whatsapp": "WhatsApp Number",
  "kyc.contact_hint": "Fill in at least one: Telegram or WhatsApp, so Admin can contact you.",
  "kyc.ktp": "ID Card (KTP) Photo",
  "kyc.ktp_hint": "The whole ID card is clearly visible, not blurry.",
  "kyc.selfie": "Selfie with ID Card",
  "kyc.selfie_hint": "Your face and ID card clearly visible in one photo.",
  "kyc.sent_title": "Registration submitted",
  "kyc.sent_body": "Your KYC data is being reviewed by Admin. You will get an email once approved, then you can log in.",
  "market.search": "Search products...",
  "market.filters": "Filters",
  "market.all_games": "All Games",
  "market.all_categories": "All Categories",
  "market.price_range": "Price Range",
  "market.in_stock": "In Stock Only",
  "market.buy": "Buy",
  "market.detail": "Detail",
  "market.stock": "Stock",
  "market.all_servers": "All Servers",
  "market.all_regions": "All Regions",
  "market.all_factions": "All Factions",
  "market.min_price": "Min price (IDR)",
  "market.max_price": "Max price (IDR)",
  "market.apply": "Apply",
  "market.reset": "Reset",
  "market.err_minmax": "Minimum price is greater than maximum",
  "market.load_failed": "Failed to load products",
  "product.description": "Description",
  "product.add_to_order": "Order Now",
  "product.quantity": "Quantity",
  "product.stock_after": "Stock left after purchase",
  "product.qty_decrease": "Decrease quantity",
  "product.qty_increase": "Increase quantity",
  "product.qty_max": "Max",
  "product.not_found": "Product not found",
  "product.not_found_sub": "This product is no longer available or has been removed.",
  "product.back": "Back to Marketplace",
  "product.login_first": "Please log in first",
  "product.buyers_only": "Only buyers can place orders",
  "product.invalid_qty": "Invalid quantity",
  "product.order_created": "Order created",
  "product.order_failed": "Failed to create order",
  "checkout.title": "Order Information",
  "checkout.sub": "Choose a delivery method and review the summary before confirming.",
  "checkout.payment_method": "Payment Method",
  "checkout.notes": "Delivery Notes",
  "checkout.place_order": "Place Order",
  "checkout.total": "Total",
  "checkout.method": "Delivery Method",
  "checkout.character": "Character Name",
  "checkout.account_id": "Account ID / User ID",
  "checkout.auction_notes": "Listing details (item, price, time)",
  "checkout.product": "Product",
  "checkout.game_server": "Game / Server",
  "checkout.qty": "Quantity",
  "checkout.unit_price": "Unit price",
  "checkout.fee": "Additional fee",
  "checkout.payment": "Payment",
  "checkout.grand_total": "Order total",
  "checkout.use_balance": "Use Store Balance",
  "checkout.balance_available": "Available",
  "checkout.balance_used": "Paid with Store Balance",
  "checkout.amount_due": "Amount to pay",
  "checkout.usd_note": "This method is paid in USD at the rate locked when the order is created.",
  "checkout.confirm": "Confirm Order",
  "checkout.processing": "Processing...",
  "delivery.mail": "Mail",
  "delivery.mail.desc": "Items are sent via in-game mail to your character.",
  "delivery.trade": "Trade / Direct Delivery",
  "delivery.trade.desc": "MQL staff meets your character in-game and trades with you.",
  "delivery.auction": "Auction House",
  "delivery.auction.desc": "You list a cheap item on the Auction House and MQL staff buys it for the order value.",
  "delivery.topup": "Direct top-up",
  "delivery.topup.desc": "Balance is sent directly to your game account/ID.",
  "delivery.service": "Service by the MQL team",
  "delivery.service.desc": "Boosting/Power Leveling/Questing is done by the MQL team. Login details and schedule are coordinated safely via Messages after payment is verified. Never put passwords in the notes.",
  "delivery.account_handover": "Account handover",
  "delivery.account_handover.desc": "Account login details are sent by staff via Messages after payment is verified.",
  "order.status.waiting_payment": "Waiting Payment",
  "order.status.verifying": "Verifying Payment",
  "order.status.preparing": "Preparing",
  "order.status.shipped": "Shipped",
  "order.status.completed": "Completed",
  "order.status.cancelled": "Cancelled",
  "order.status.resolution": "Resolution",
  "order.status.trade_ready": "Staff Ready to Trade",
  "order.status.partial_delivery": "Partial Delivery",
  "order.upload_proof": "Upload Payment Proof",
  "order.my_orders": "My Orders",
  "order.sales": "Sales Orders",
  "order.all": "All",
  "order.no": "Order No.",
  "order.date": "Date",
  "order.items": "Items",
  "order.status": "Status",
  "order.detail": "Detail",
  "order.back": "← Back",
  "order.payment_proof": "Payment Proof",
  "order.history": "Status History",
  "order.payment": "Payment",
  "order.delivery": "Delivery",
  "order.character": "Character / ID",
  "order.send": "Send",
  "order.proof_sent": "Payment proof sent",
  "order.upload_failed": "Upload failed",
  "order.max_5mb": "Max 5MB",
  "order.trade_ready_badge": "Ready to Trade",
  "order.trade_ready_title": "Staff is ready to trade now",
  "order.trade_ready_char": "Please go online in game with character",
  "order.shipped_title": "Items have been delivered",
  "order.progress": "Delivery Progress",
  "order.delivered": "delivered",
  "order.refund": "Refunded to Store Balance",
  "order.balance_used": "Paid with Store Balance",
  "order.amount_due": "Amount to pay",
  "order.unique_code": "Unique code",
  "order.pay_within": "Pay before the time runs out or the order is cancelled automatically",
  "order.pay_expired": "Payment time is over — the order is being cancelled",
  "product.min_order": "Minimum purchase",
  "product.min_order_err": "Minimum purchase for this product is {amount}",
  "order.transfer_exact": "Please transfer the EXACT amount above (includes unique code +{code}) so your payment is identified quickly.",
  "order.scan_qris": "Scan with any banking / e-wallet app — the amount fills in automatically.",
  "order.scan_usdt": "Scan with your crypto wallet to copy the address.",
  "order.usdt_warning": "Send USDT on the TRON (TRC20) network only. Other networks will be lost.",
  "order.usdt_network_warning": "Send USDT on the {network} network only. Transfers on other networks may be lost.",
  "order.usdt_locked": "Locked rate: 1 USDT = {rate} · Total {total}",
  "order.binance_scan": "Scan with the Binance app (Pay) or send to the UID below",
  "order.binance_name": "Account name",
  "order.binance_exact": "Pay the exact USDT amount above, then upload your payment proof.",
  "checkout.usdt_note": "Auto-converted at the latest rate, rounded up to 2 decimals. The rate is locked when the order is created. 1 USDT = {rate}",
  "checkout.fx_changed": "The rate has just updated. Please check the new USDT amount and confirm again.",
  "order.rate": "Rate",
  "notif.title": "Notifications",
  "notif.empty": "No notifications yet",
  "balance.title": "Store Balance",
  "balance.desc": "Refunds for undelivered parts of cancelled orders. Can be used for your next purchases at MQL; cannot be withdrawn.",
  "balance.history": "Balance History",
  "balance.refund": "Refund",
  "balance.payment": "Payment",
  "footer.contact": "MQL Store — Contact Information",
  "footer.phone": "Phone",
  "policy.buyer": "Buyer Policy",
  "policy.supplier": "Supplier Policy",
  "policy.updated": "Version",
  "policy.lang_note": "",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.actions": "Actions",
  "common.loading": "Loading...",
  "common.empty": "No data yet",
  "dashboard.new_orders": "New Orders",
  "dashboard.to_process": "To Process",
  "dashboard.completed": "Completed",
  "dashboard.total_sales": "Total Sales",
  "dashboard.stock_available": "Available Stock",
  "dashboard.pending_reviews": "Stock Reviews",
  "chat.new": "New Conversation",
  "chat.type_message": "Type a message...",
  "chat.type_message_paste": "Type a message... (Ctrl+V to paste a screenshot)",
  "chat.latest": "Latest messages",
  "chat.image_ready": "Image ready. Press send to deliver.",
  "chat.send": "Send",
  "chat.attach_image": "Attach Image",
  "chat.video_url": "Video URL",
  "chat.select": "Select a conversation",
  "acct.label": "ACCOUNT",
  "acct.title": "Account Settings",
  "acct.profile": "Profile",
  "acct.role": "Role",
  "role.owner": "Owner",
  "role.staff": "Staff",
  "role.supplier": "Supplier",
  "role.buyer": "Buyer",
  "acct.change_pw": "Change Password",
  "acct.current_pw": "Current password",
  "acct.new_pw": "New password (min. 8 characters)",
  "acct.confirm_pw": "Repeat new password",
  "acct.save_pw": "Save New Password",
  "acct.saving": "Saving...",
  "acct.pw_mismatch": "Password confirmation does not match",
  "acct.pw_changed": "Password changed. Sessions on other devices were signed out.",
  "twofa.codes_copied": "Recovery codes copied",
  "twofa.codes_note": "Keep these recovery codes somewhere safe. Each code works once if you lose your phone. They will not be shown again.",
  "twofa.copy": "Copy",
  "twofa.saved": "I have saved them",
  "twofa.enable_start": "Enable Google Authenticator",
  "twofa.step1": "1. Scan this QR code with the Google Authenticator app.",
  "twofa.manual": "Can't scan? Enter this key manually:",
  "twofa.step2": "2. Enter the 6-digit code shown in the app.",
  "twofa.verify": "Verify & Enable",
  "twofa.code_label": "Authenticator code",
  "twofa.regen": "Generate new recovery codes",
  "twofa.mandatory_note": "2FA is mandatory for Owner/Staff accounts and cannot be turned off. If a staff member loses their phone, the Owner can reset 2FA in Manage → Staff Accounts.",
  "twofa.disable": "Turn off 2FA",
  "twofa.disabled": "2FA turned off",
  "twofa.on": "2FA is on — login requires an Authenticator code.",
  "twofa.required": "2FA is required for your account. Enable it now to unlock Owner/Staff menus.",
  "twofa.off": "2FA is not enabled.",
  "twofa.enabled": "2FA enabled",
  "sound.title": "Notification Sounds",
  "sound.order": "Order sound",
  "sound.message": "Message sound",
  "sound.volume": "Volume",
  "sound.off": "Off",
  "sound.chime": "Chime",
  "sound.bell": "Bell",
  "sound.coin": "Coin",
  "sound.ping": "Ping",
  "sound.test": "Test",
  "sound.saved": "Sound settings saved",
  "sound.custom_group": "Store sounds",
  "sound.autoplay_note": "Sounds play while the site is open, after you have clicked somewhere on the page (browser rule).",
  "order.watch_video": "Watch delivery proof video",
  "order.chat_staff": "Chat with Staff",
  "maint.title": "Under Maintenance",
  "maint.countdown": "Scheduled maintenance starts in",
  "maint.sub": "We are upgrading MQL Group. Your account, orders and Store Balance are safe.",
  "maint.staff_banner": "MAINTENANCE MODE ON — buyers & suppliers cannot access the site",
  "maint.staff_login": "Owner / Staff login",
  "order.refund_title": "{amount} has been refunded to your Store Balance",
  "order.refund_body": "Your money is safe. It covers the undelivered part of this order and can be used right away for your next purchase.",
  "order.chat_failed": "Could not open the chat",
};

export default en;
